import api from "./api";

function createThirdPartyRefund(thirdPartyPaymentId, amount) {
  return api
    .post(`api/thirdpartyrefunds`, { thirdPartyPaymentId, amount })
    .then(res => res.data);
}

export { createThirdPartyRefund };
